import React, { useState } from 'react'
import { Box, styled } from '@mui/material'
import { Skeleton } from '@mui/material'
import { DecisionConfirmationButton } from 'components'
import {
    useRequestItemApprovalDecisions,
    useSubmitRequestItemDecision,
} from 'hooks'
import { mobileScreenWidth } from 'utils'
import { ViolatingItemDecision } from './ViolatingItemDecision'
import { useAccessRequestPolicy } from 'hooks'

const DecisionButtonsContainer = styled(Box)({
    flex: '1',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '15px 30px',

    [`@media (max-width:${mobileScreenWidth})`]: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        '& >span': {
            marginBottom: '12px',
        },
    },
})

export const ItemApprovalDecisionPrompt = ({ requestItem, refetch }) => {
    const {
        data: approvalDecisions,
        isLoading: isLoadingApprovalDecisions,
        refetch: refetchDecisions,
    } = useRequestItemApprovalDecisions(
        requestItem.id,
        requestItem.isApprovable,
    )
    const policy = useAccessRequestPolicy(requestItem?.requestPolicyId)

    const [decisionComment, setDecisionComment] = useState('')

    const [startDate, setStartDate] = useState(
        requestItem.requestDataAssignmentStartDate,
    )
    const [endDate, setEndDate] = useState(
        requestItem.requestDataAssignmentEndDate,
    )
    const [timeConstrainedControl, setTimeConstrainedControl] = useState(false)

    const [
        submitRequestItemDecision,
        { isLoading: isSubmittingRequestItemDecision },
    ] = useSubmitRequestItemDecision(
        requestItem.businessRequestId,
        requestItem.id,
    )

    return (
        <DecisionButtonsContainer>
            {isLoadingApprovalDecisions ? (
                <Box marginX="30px">
                    <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={192}
                        height={40}
                    />
                </Box>
            ) : requestItem.isViolatingItem ? (
                <ViolatingItemDecision
                    item={requestItem}
                    decisions={approvalDecisions}
                />
            ) : (
                approvalDecisions &&
                approvalDecisions.map((ad) => (
                    <Box component="span" key={ad.decisionId} marginX="12px">
                        <DecisionConfirmationButton
                            approvalDecision={ad}
                            decisionComment={decisionComment}
                            setDecisionComment={setDecisionComment}
                            isLoading={isSubmittingRequestItemDecision}
                            showTimeConstraintControl={
                                ad.isTimeConstraintEditable
                            }
                            requireTimeControl={ad.isTimeConstraintRequired}
                            startDate={startDate}
                            endDate={endDate}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            policy={policy}
                            handleToggleValue={setTimeConstrainedControl}
                            onSuccess={() => {
                                const reqData = {
                                    id: requestItem.id,
                                    stepId: requestItem.currentApprovalStepId,
                                    decisionId: ad.decisionId,
                                    requestDataAssignmentStartDate:
                                        timeConstrainedControl
                                            ? startDate
                                            : null,
                                    requestDataAssignmentEndDate:
                                        timeConstrainedControl ? endDate : null,
                                }
                                if (decisionComment) {
                                    reqData.comment = decisionComment
                                }

                                return submitRequestItemDecision([
                                    reqData,
                                ]).then(() => {
                                    refetch()
                                    refetchDecisions()
                                })
                            }}
                        />
                    </Box>
                ))
            )}
        </DecisionButtonsContainer>
    )
}
